import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";
import { MessageList } from "../../config/Message";


export const getMessageList = catchAsync(async () => {  
    const data = await httpsCall.post<MessageList>(`messages/message/list`);
    return data;
});
export const getChatBoardList = catchAsync(async (chatId) => {  
    const data = await httpsCall.get<any>(`messages/${chatId}`);
    return data;
});

export const messageSend = catchAsync(async (values= {}) => {  
    const data = await httpsCall.post<any>(`messages/sendMessage`, values);
    return data;
});

export const getAdmin = catchAsync(async () => {  
    const data = await httpsCall.get<any>(`messages/getAdmin`);
    return data;
}); 



